import { render, staticRenderFns } from "./createCommunity.vue?vue&type=template&id=230eba12&scoped=true"
import script from "./createCommunity.vue?vue&type=script&lang=js"
export * from "./createCommunity.vue?vue&type=script&lang=js"
import style0 from "./createCommunity.vue?vue&type=style&index=0&id=230eba12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230eba12",
  null
  
)

export default component.exports